import React, { useState, Fragment } from "react";
import { FaEllipsisH } from "react-icons/fa";
import PopupMenu from "../../SimpleForm/PopupMenu";
import moment from "moment-timezone";
import "./MainAccountView.scss";
import { store } from "../../../global/app/store";
import { resendInvitation } from "../actions/action_resendInvitation";
import { revokeInvitation } from "../actions/action_revokeInvitation";
import ReactTooltip from "react-tooltip";
const { dispatch } = store;

const getCurrentUser = () => {
  let state = store.getState();
  if (state) {
    return state.appReducer.userDataReducer.data;
  }
};

const resendInvitations = (props) => {
  let currentUser = getCurrentUser();
  if (currentUser) {
    dispatch(resendInvitation({ props, currentUser }));
  }
};

const cancelInvitation = (props) => {
  let currentUser = getCurrentUser();
  if (currentUser) {
    dispatch(revokeInvitation({ props, currentUser }));
  }
};

const EditButton = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <div className="buttonHolder">
      <button
        className="usa-button usa-button--outline editButton"
        onClick={() => setModalIsOpen(!modalIsOpen)}
      >
        Edit
      </button>
    </div>
  );
};

const handleEdit = (props) => {
  console.log("edit");
};

const contentStyle = {
  boxShadow: "inset 0px 4px 0px 0px #AEB0B5, 0 2px 6px 0 rgba(0,0,0,0.5)",
  padding: "0",
  paddingTop: "4px",
  border: "none",
};

const arrowStyle = {
  width: "0",
  height: "0",
  borderStyle: "solid",
  borderWidth: "0 0 13px 13px",
  outline: "none",
  borderColor: "transparent transparent #AEB0B5 transparent",
  background: "transparent",
  boxShadow: "none",
};

const requesteColumns = [
  {
    Header: "Email Address",
    accessor: "recipientEmail",
    Cell: ({ value, row: { index }, column: { id } }) => (
      <Fragment>
        <span
          title={value}
          className="cell"
          data-tip
          data-for={`${id}${index}`}
        >
          {value}
        </span>
        <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
          <span>{value}</span>
        </ReactTooltip>
      </Fragment>
    ),
  },
  {
    Header: "Date Requested",
    accessor: "date_requested",
    Cell: ({ value, row: { index }, column: { id } }) => {
      let date = value ? moment.tz(new Date(value), "America/New_York") : "n/a";
      date = date.format("ddd MMM D YYYY");
      return (
        <Fragment>
          <span
            title={date}
            className="cell"
            data-tip
            data-for={`${id}${index}`}
          >
            {date}
          </span>
          <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
            <span>{date}</span>
          </ReactTooltip>
        </Fragment>
      );
    },
  },
  {
    Header: "Status",
    accessor: "invitation_status",
    Cell: ({ value, row: { index }, column: { id } }) => (
      <Fragment>
        <span
          title={value}
          className="cell"
          data-tip
          data-for={`${id}${index}`}
        >
          {value}
        </span>
        <ReactTooltip id={`${id}${index}`} type="dark" effect="solid">
          <span>{value}</span>
        </ReactTooltip>
      </Fragment>
    ),
  },
  {
    Header: "Action",
    show: true,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <Fragment>
        <PopupMenu
          contentStyle={contentStyle}
          arrowStyle={arrowStyle}
          trigger={
            <FaEllipsisH
              className="EllipsisIcon"
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(original)}
            />
          }
          position="bottom right"
          closeOnDocumentClick
        >
          <div>
            <div className="Memenunu">
              <div className="menu-item dropdown-label-View">
                <span
                  style={{ color: "#0071BB", cursor: "pointer" }}
                  onClick={() => {
                    resendInvitations(original);
                  }}
                >
                  Resend
                </span>
              </div>
            </div>
            <hr />
            <div className="menu">
              <div className="menu-item dropdown-label-View">
                <span
                  style={{ color: "#9C1712", cursor: "pointer" }}
                  onClick={() => {
                    cancelInvitation(original);
                  }}
                >
                  Cancel
                </span>
              </div>
            </div>
          </div>
        </PopupMenu>
      </Fragment>
    ),
    fixedWidth: 130,
  },
];

export { requesteColumns };
